export default [

  {
    path: '*',
    meta: {
      public: true,
    },
    redirect: {
      path: '/404'
    }
  },  
  {
    path: '/404',
    meta: {
      public: true,
    },
    name: 'NotFound',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/NotFound.vue`
    )
  },
    {
        path: '/login',
        meta: {
            public: true,
        },
        name: 'NotFound',
        component: () => import(
            /* webpackChunkName: "routes" */
            /* webpackMode: "lazy-once" */
            `@/pages/Login.vue`
            )
    },
  {
    path: '/403',
    meta: {
      public: true,
    },
    name: 'AccessDenied',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/Deny.vue`
    )
  },
  {
    path: '/500',
    meta: {
      public: true,
    },
    name: 'ServerError',
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/Error.vue`
    )
  },
  {
    path: '/',
    meta: { },
    name: 'Root',
    redirect: {
      name: 'الصفحة الرئيسية'
    }
  },
    {
        path: '/dashboard/fr',
        meta: {breadcrumb: true,fr:true},

        name: '',
        component: () => import(
            `@/pages/DashboardFR.vue`
            ), redirect: {
        path: '/dashboard/fr/table1/Toutes les villes'
    },
        children: [

            {
                path: '/dashboard/fr/table1/:state',
                name: '',
                meta: {breadcrumb: true,fr:true},

                props: true,
                components: {
                    default: () => import(
                        /* webpackChunkName: "routes" */
                        /* webpackMode: "lazy-once" */
                        `@/components/table1FR.vue`
                        ),
                }
            },

            {
                path: '/dashboard/fr/table2/:state',

                name: '',
                props: true,
                components: {
                    default: () => import(
                        /* webpackChunkName: "routes" */
                        /* webpackMode: "lazy-once" */
                        `@/components/table2FR.vue`
                        ),
                }
            },
            {
                path: '/dashboard/fr/table3/:state',
                name: '',
                props: true,
                meta: {breadcrumb: true,fr:true},

                components: {
                    default: () => import(
                        /* webpackChunkName: "routes" */
                        /* webpackMode: "lazy-once" */
                        `@/components/table3FR.vue`
                        ),
                }
            },
            {
                path: '/dashboard/fr/table4/:state',
                name: '',
                props: true,
                meta: {breadcrumb: true,fr:true},

                components: {
                    default: () => import(
                        /* webpackChunkName: "routes" */
                        /* webpackMode: "lazy-once" */
                        `@/components/table4FR.vue`
                        ),
                }
            },
            {
                path: '/dashboard/fr/table5/:state',
                name: '',
                props: true,
                meta: {breadcrumb: true,fr:true},

                components: {
                    default: () => import(
                        /* webpackChunkName: "routes" */
                        /* webpackMode: "lazy-once" */
                        `@/components/table5FR.vue`
                        ),
                }
            },

            {
                path: '/dashboard/fr/table6/:state',
                name: '',
                props: true,
                meta: {breadcrumb: true,fr:true},

                components: {
                    default: () => import(
                        /* webpackChunkName: "routes" */
                        /* webpackMode: "lazy-once" */
                        `@/components/table6FR.vue`
                        ),
                }
            },

            {
                path: '/dashboard/fr/table7/:state',
                name: '',
                props: true,
                meta: {breadcrumb: true,fr:true},

                components: {
                    default: () => import(
                        /* webpackChunkName: "routes" */
                        /* webpackMode: "lazy-once" */
                        `@/components/table7FR.vue`
                        ),
                }
            },
            ]

    },

  {
    path: '/dashboard',
    meta: { breadcrumb: true,fr:false },
    name: '',
    component: () => import(
      `@/pages/Dashboard.vue`
    ),    redirect: {
      path: '/dashboard/table1/الكل'
  },
      children: [
          {
              path: '/dashboard/table1/:state',
              name: '',

              props: true,
              components: {
                  default: () => import(
                      /* webpackChunkName: "routes" */
                      /* webpackMode: "lazy-once" */
                      `@/components/table1.vue`
                      ),
              }
          },
          {
              path: '/dashboard/table2/:state',

              name: '',
              props: true,
              components: {
                  default: () => import(
                      /* webpackChunkName: "routes" */
                      /* webpackMode: "lazy-once" */
                      `@/components/table2.vue`
                      ),
              }
          },
          {
              path: '/dashboard/table3/:state',

              name: '',
              props: true,
              components: {
                  default: () => import(
                      /* webpackChunkName: "routes" */
                      /* webpackMode: "lazy-once" */
                      `@/components/table3.vue`
                      ),
              }
          },
          {
              path: '/dashboard/table4/:state',

              name: '',
              props: true,
              components: {
                  default: () => import(
                      /* webpackChunkName: "routes" */
                      /* webpackMode: "lazy-once" */
                      `@/components/table4.vue`
                      ),
              }
          },
          {
              path: '/dashboard/table5/:state',

              name: '',
              props: true,
              components: {
                  default: () => import(
                      /* webpackChunkName: "routes" */
                      /* webpackMode: "lazy-once" */
                      `@/components/table5.vue`
                      ),
              }
          },
          {
              path: '/dashboard/table6/:state',

              name: '',
              props: true,
              components: {
                  default: () => import(
                      /* webpackChunkName: "routes" */
                      /* webpackMode: "lazy-once" */
                      `@/components/table6.vue`
                      ),
              }
          },
          {
              path: '/dashboard/table7/:state',

              name: '',
              props: true,
              components: {
                  default: () => import(
                      /* webpackChunkName: "routes" */
                      /* webpackMode: "lazy-once" */
                      `@/components/table7.vue`
                      ),
              }
          },


      ]
  },
  {
    path: '/accueil',
    meta: { },
    name: 'الصفحة الرئيسية',
    props: (route) => ({ type: route.query.type }),
    component: () => import(
      /* webpackChunkName: "routes" */
      /* webpackMode: "lazy-once" */
      `@/pages/accueil.vue`
    )
  },

    {
        path: '/accueil/fr',
        meta: {breadcrumb: true,fr:true},
        name: 'Accueil',
        props: (route) => ({ type: route.query.type }),
        component: () => import(
            /* webpackChunkName: "routes" */
            /* webpackMode: "lazy-once" */
            `@/pages/accueilFR.vue`
            )
    },


    {
        path: '/database/DB/fr',
        meta: {public: true,},
        name: '',
        component: () => import(
            /* webpackChunkName: "routes" */
            /* webpackMode: "lazy-once" */
            `@/pages/BD.vue`
            ),
    },
    {
        path: '/database/DB/Ar',
        meta: {public: true,},
        name: '',
        component: () => import(
            /* webpackChunkName: "routes" */
            /* webpackMode: "lazy-once" */
            `@/pages/BDAr.vue`
            ),
    },

];



// WEBPACK FOOTER //
// ./src/router/paths.js